import Image from 'next/image';
import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 1240px;
  margin: 40px auto;
`;

export const BannerWrapper = styled.div`
  width: 100%;
  height: 500px;
  margin-bottom: 40px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    height: 250px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    height: 129px;
  }
`;

export const Banner = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: relative !important;
`;

export const TextContentWrapper = styled.div`
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0 25px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    padding: 0 15px;
  }
`;

export const Title = styled.span`
  font-size: 36px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.darkGrey};
  margin-bottom: 20px;
  display: block;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 24px;
    margin-bottom: 11px;
  }
`;
export const Description = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.darkGrey};
  margin-bottom: 20px;
  line-height: 1.5;
  display: block;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 14px;
    margin-bottom: 30px;
  }
`;

export const Label = styled.span`
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.darkGrey};
  margin-bottom: 26px;
  display: block;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 18px;
    margin-bottom: 15px;
  }
`;

export const ConditionsItem = styled.div`
  margin-bottom: 10px;
  display: grid;
  grid-template-columns: 10px 1fr;
  gap: 0 20px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    gap: 0 5px;
  }
`;
export const ConditionsText = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.darkGrey};
  line-height: 1.5;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 14px;
  }
`;
export const ConditionsDot = styled.span`
  display: block;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  margin: 10px 0 0 0;
  background-color: ${({ theme }) => theme.palette.coral};
`;
